import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTextArea } from './TextArea.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTextArea({ prefix }));
}
